import { render, staticRenderFns } from "./WhitelabelLink.vue?vue&type=template&id=132860b8&scoped=true&"
import script from "./WhitelabelLink.vue?vue&type=script&lang=ts&"
export * from "./WhitelabelLink.vue?vue&type=script&lang=ts&"
import style0 from "./WhitelabelLink.vue?vue&type=style&index=0&id=132860b8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132860b8",
  null
  
)

export default component.exports